export var ADMIN_HOME = "/home";
/** People */
export var ADD_PEOPLE_SINGLE = "/people/add/single";
export var ADD_PEOPLE_MULTIPLE = "/people/add/multiple";
export var VIEW_PEOPLE = "/people/view";
/** Teams */
export var VIEW_TEAM = "/teams/view";
export var ADD_TEAM = "/teams/add";
/**
 * Settings
 * - customisation
 * - roles and permissions
 * - login and integrations
 */
export var SETTINGS_BASE = "/settings";
export var SETTINGS_CUSTOMISE = "/settings/customisation";
export var SETTINGS_CUSTOMISE_BRAND = SETTINGS_CUSTOMISE + "/brand";
export var SETTINGS_CUSTOMISE_WELCOME_EMAIL = SETTINGS_CUSTOMISE + "/welcome-message";
export var SETTINGS_CUSTOMISE_PERKS_VISIBILITY = SETTINGS_CUSTOMISE + "/perk-visibility";
export var SETTINGS_CUSTOMISE_BENEFITS = SETTINGS_CUSTOMISE + "/benefits";
export var SETTINGS_CUSTOMISE_BENEFITS_VIEW = SETTINGS_CUSTOMISE + "/benefits/view";
export var SETTINGS_CUSTOMISE_BENEFITS_SETTINGS = SETTINGS_CUSTOMISE + "/benefits/settings";
export var SETTINGS_CUSTOMISE_VALUES = SETTINGS_CUSTOMISE + "/values";
export var SETTINGS_CUSTOMISE_VALUES_VIEW = SETTINGS_CUSTOMISE + "/values/view";
export var SETTINGS_CUSTOMISE_CELEBRATIONS = SETTINGS_CUSTOMISE + "/celebrations";
/** Roles and permissions */
export var SETTINGS_PERMISSIONS_RECOGNITION = SETTINGS_BASE + "/roles-and-permissions/recognition";
/** Login and integrations */
export var SETTINGS_LOGIN_SSU = SETTINGS_BASE + "/login/ssu";
export var SETTINGS_LOGIN_SSO = SETTINGS_BASE + "/login/sso";
/** Reporting */
export var REPORTING_V2 = "/reporting-v2";
export var REPORTING_V2_PERKS = "/reporting-v2/perks";
export var REPORTING_V2_PLATFORM = "/reporting-v2/platform";
/** Help */
export var HELP = "/help";
export var ROLES_COMING_SOON = SETTINGS_BASE + "/roles-and-permissions/coming-soon";
